import React, {Component} from 'react';
import  SlackNotify  from 'slack-notify';
import NotificationSystem from 'react-notification-system';
import { Button, FormGroup, Input, FormText } from 'reactstrap'
import {appHelpers} from "../../utils/app.helpers";
import { appConstants } from "../../utils/constants";

class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentErrorMessages: [],
            name: '',
            email: '',
            message: '',
            isChecked: false,
            requesting: false,
            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };
    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        const {name, email, message} = this.state;
        if(name === ''){
            _errs_['name'] = 'Please enter name';
            formValid = false;
        }
        if(this.validateEmail(email)){
            _errs_['email'] = 'Please enter valid email address';
            formValid = false;
        }
        if(message === '') {
            _errs_['message'] = 'Please enter message';
            formValid = false;
        }else if(message.length < 5) {
            _errs_['message'] = 'Message is too short';
            formValid = false;
        }

        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    validateEmail = (email_) => {
        let re =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
        return (email_  === '' || !re.test(email_ ));
    };

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };
    handleCheckboxChange = (event) => {
        this.setState({
            ...this.state,
            isChecked: event.target.checked
        });
    };

    handleSubmit = () => {
        if(this.validateInput()){
            this.postContact();
        }
    };
    postContactOnSlack = () => {
        const {name, email, message} = this.state;
        let sn = new SlackNotify('https://hooks.slack.com/services/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');
        this.setState({requesting: true});
        sn.send({
            channel: 'avitechcare',
            attachments: [
                {
                    fallback: message,
                    text: message,
                    "color": "#030f1f",
                    fields: [
                        { title: 'Name', value: name, short: true },
                        { title: 'Email', value: email, short: true }
                    ]
                }
            ]
        },  (err) => {
            if(err){
                this.setState({requesting: false});
                this.notify('Oops!, temporary unable to send message. Please try again later', 'error');
            }else{
                this.setState({requesting: false});
                this.resetForm();
                this.notify('Message sent successfully', 'success');
            }
        });
    };
    postContact = () => {
        const { message} = this.state;
        this.setState({requesting: true});
        const payload  = {
            "@context": "https://schema.org/extensions",
            "@type": "MessageCard",
            "themeColor": "85171f",
            "title": "Avitech Contact Form",
            "text": message,
            "potentialAction": [
                {
                    "@type": "OpenUri",
                    "name": "Visit Website",
                    "themeColor": "85171f",
                    "targets": [
                        { "os": "default", "uri": "http://avitechng.com" }
                    ]
                }
            ]
        };
        appHelpers.postRequest(appConstants.CONTACT_WEB_HOOK_URL, payload)
            .then(res => {
                this.setState({requesting: false});
                this.resetForm();
                this.notify('Message sent successfully', 'success');
            }).catch(err =>{
            this.setState({requesting: false});
            this.notify('Oops!, temporary unable to send message. Please try again later', 'error');
        });
    };
    resetForm() {
        this.setState({name: '', email: '', componentErrorMessages: [], message: ''});
    };
    render() {
        const { name, email, message, componentErrorMessages, requesting } = this.state;
        console.log('State ', this.state.isChecked)
        return (
            <div>
                <FormGroup className={"mb-4 " + (componentErrorMessages.name ? 'has-danger' : '')}>
                    <Input type="text" placeholder="Name" value={name} onChange={(event) => this.handleChange(event, 'name')}/>
                    { componentErrorMessages.name && <FormText color="danger"> {componentErrorMessages.name }</FormText> }
                </FormGroup>
                <FormGroup className={"mb-4 " + (componentErrorMessages.email ? 'has-danger' : '')}>
                    <Input type="text" placeholder="Email" value={email} onChange={(event) => this.handleChange(event, 'email')}/>
                    { componentErrorMessages.email && <FormText color="danger"> {componentErrorMessages.email }</FormText> }
                </FormGroup>
                <FormGroup className={"mb-4 " + (componentErrorMessages.message ? 'has-danger' : '')}>
                    <Input type="textarea" style={{height:200}} placeholder="Message" value={message} onChange={(event) => this.handleChange(event, 'message')}/>
                    { componentErrorMessages.message && <FormText color="danger"> {componentErrorMessages.message }</FormText> }
                </FormGroup>
                <FormGroup check inline>
                    <Input type="checkbox" onChange={(event) => this.handleCheckboxChange(event)} />
                    By clicking “SUBMIT” you agree we can collect and process your personal data in accordance to this <a href="/privacy-notice" target="_blank" className='text-danger'>privacy notice</a> and our <a href="/privacy-policy" target="_blank" className='text-danger'>privacy policy</a>
                </FormGroup>
                <FormGroup>
                    <Button color="primary" className='btn-block btn2' disabled={requesting || !this.state.isChecked} onClick={this.handleSubmit}> Send </Button>{' '}
                </FormGroup>
                <NotificationSystem ref="notificationSystem"/>
            </div>
        );
    }
}

export default ContactForm;




// WEBPACK FOOTER //
// ./src/views/contact-us/contact-form.js